import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { _baseUrl } from '../../helper/global-helper';
import { retry } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusDataRetrievalService {

  private baseUrl: string;

  constructor(private http: HttpClient) { 
    this.baseUrl = _baseUrl;
  }

  public getBusTopology(){
    return this.http.get(this.baseUrl + 'dataresource/bustopology', {
      observe: 'response',
      responseType: 'json',
    }).pipe(
      retry(3)
    );
  }

}
